import { render } from "./RegistrationDocumentBlockComponent.vue?vue&type=template&id=e7ef314c&scoped=true"
import script from "./RegistrationDocumentBlockComponent.vue?vue&type=script&lang=js"
export * from "./RegistrationDocumentBlockComponent.vue?vue&type=script&lang=js"

import "./RegistrationDocumentBlockComponent.vue?vue&type=style&index=0&id=e7ef314c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7ef314c"]])

export default __exports__